import { wencesApi } from "@/api/wencesApi";

export default async function isAdminRoleGuard(to, from, next) {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      next("/login");
      return;
    }

    // myrole devuelve el nombre del rol (populate); myprofile devuelve role como ID sin popular
    const roleResponse = await wencesApi.get("/api/users/myrole", {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!roleResponse.data?.success) {
      next("/login");
      return;
    }

    const roleName = roleResponse.data.data?.role;

    if (roleName === "admin") {
      next();
    } else {
      next("/dashboard");
    }
  } catch (error) {
    console.error("Error in admin role guard:", error);
    next("/login");
  }
}
